module.exports = __webpack_public_path__ + "img/violin.581f8914.gif";